export default "__VITE_ASSET__DQMQm2sA__"